import { Checkbox, useAlert } from "matsuri-ui"
import { useState } from "react"
import { requestSetInspectionByManager } from "@/hooks/useCleanings"
import { useAuth } from "@/hooks/useAuth"
import { useCompanyAssignmentStatus } from "@/hooks/useCompanyAssignmentStatus"

interface Props {
    cleaningId: string
    cleaningCompanyId: string | undefined
    hasInspection: boolean | undefined
    onSaved?: () => void
}

export const InspectionField = ({
    cleaningId,
    cleaningCompanyId,
    hasInspection,
    onSaved
}: Props) => {
    const { token } = useAuth()
    const { throwAlert } = useAlert()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const { isAssignedCompany } = useCompanyAssignmentStatus({
        cleaningCompanyId
    })

    if (!isAssignedCompany) return null

    const handleChange = async (checked: boolean) => {
        setIsSubmitting(true)
        const { error } = await requestSetInspectionByManager(
            token,
            cleaningId,
            checked
        )
        setIsSubmitting(false)
        throwAlert(error, {
            errorMessage: "インスペクター同行の保存に失敗しました",
            onSuccess: () => {
                onSaved?.()
            }
        })
    }

    return (
        <Checkbox
            checked={hasInspection === true}
            onChange={e => void handleChange(e.target.checked)}
            disabled={isSubmitting}
        >
            インスペクター同行あり
        </Checkbox>
    )
}
